import { useState } from "react";

export function useForceUpdate() {
	const setValue = useState(0)[1]; // integer state
	return () => setValue((value) => value + 1); // update the state to force render
}
